import {MutationTree} from "vuex";
import VideoPlayerWidgetState from "@/apps/VideoPlayerWidget/models/video-player-widget-state";

export default <MutationTree<VideoPlayerWidgetState>>{
    setImage(state, image: string) {
        state.image = image;
    },

    setVideoActive(state, videoActive: boolean) {
        state.videoActive = videoActive;
    },

    setPlayer(state, player: any) {
        state.player = player;
    }
}
